<template>
	<div v-if="isVisible" class="modal-overlay">
		<div class="open-member-dialog">
			<div class="head-body"
				:class="{ 'bg-normal': userVipInfo.vip_status == 0, 'bg-active': userVipInfo.vip_status == 1 }">
				<div class="head-body-msg">
					<div class="icon-name">
						<img src="@/assets/member_name.png" alt="">
					</div>
					<div class="head-tips" :class="{ 'tips-vip': userVipInfo.vip_status == 1 }">
						{{ userVipInfo.vip_status == 0 ? '你还不是快兔会员，无法享受会员权益' : '会员有效期至 ' + userVipInfo.vip_info.time_end
						}}
					</div>
					<div class="close-btn" @click="closeDialog">
						<img src="@/assets/ic_close.png" alt="">
					</div>
				</div>
			</div>
			<div class="body-content">
				<div class="content-left">
					<div class="content-left-body">
						<div class="left-main">
							<div class="left-main-title">会员尊享权益</div>
							<div class="left-main-list">
								<div class="left-main-list-item" v-for="(item, index) in memberOptions" :key="index">
									<div class="left-main-list-item-icon">
										<img :src="item.icon" alt="">
									</div>
									<div class="left-main-list-item-title">
										{{ item.title }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="content-right" v-if="productsArr.length > 0">
					<div class="content-right-body">
						<div class="products-list-container" @mouseenter="showDirection" @mouseleave="hideDirection">
							<div class="products-list" ref="productsList">
								<div class="product-item" v-for="(item, index) in productsArr" :key="index"
									:class="{ 'active': selectedProductIndex === index }" @click="selectProduct(index)">
									<div class="product-item-body"
										:class="{ 'product-item-body-selected': selectedProductIndex === index }">
										<div class="product-title"
											:class="{ 'product-title-selected': selectedProductIndex === index }">{{
												item.title }}</div>
										<div class="product-price-body"
											:class="{ 'product-price-body-selected': selectedProductIndex === index }">
											<div>¥</div>
											<div>{{ item.first_price > 0 ? item.first_price : item.sell_price }}</div>
										</div>
										<div class="product-price-show"
											:class="{ 'product-price-show-selected': selectedProductIndex === index }">
											¥{{ item.show_price }}</div>
										<div class="product-price-discount"
											:class="{ 'product-price-discount-selected': selectedProductIndex === index }">
											立减¥{{ item.unit_price2 }}</div>
									</div>
									<div v-if="item.label_id != 0" class="product-lable">{{ item.label }}</div>
								</div>
							</div>
							<div class="icon-direction icon-direction-left"
								v-if="productsArr.length >= 5 && isShowDirection" @click="scrollList('left')"
								@mouseenter="showDirection">
								<img src="@/assets/ic_direction.png" alt="">
							</div>
							<div class="icon-direction icon-direction-right"
								v-if="productsArr.length >= 5 && isShowDirection" @click="scrollList('right')"
								@mouseenter="showDirection">
								<img src="@/assets/ic_direction.png" alt="">
							</div>
						</div>
						<div class="auto-renew-tip">
							<div class="auto-renew-tip-title" v-if="productsArr.length > 0">自动续费{{
								productsArr[selectedProductIndex].sell_price }}/月，可随时取消</div>
						</div>
						<div class="pay-content" v-if="payArr.length > 0">
							<div class="qrcode-body">
								<div class="qrcode-body-content">
									<div class="qrcode">
										<QrcodeGenerator :text="qrCodeText" :size="120"
											:options="{ color: { dark: '#000000', light: '#ffffff' } }" />
										<div class="refresh-body" v-if="isQrCodeExpired" @click="refreshQrCode">
											<div class="refresh-ic">
												<img src="@/assets/ic_refresh.png" alt="">
											</div>
											<div class="refresh-tip">点击刷新二维码</div>
										</div>
									</div>
									<div class="qrcode-title">打开{{ payArr.find(item => item.payment_id ===
										selectedPayType).payment_name }}扫一扫</div>
								</div>
							</div>
							<div class="pay-type-body">
								<div class="pay-type-body-content">
									<div class="pay-type-arr">
										<div class="pay-item"
											:class="{ 'pay-item-selected': selectedPayType === item.payment_id }"
											v-for="(item, index) in payArr" :key="index"
											@click="changePayType(item.payment_id)">
											<div></div>
											<div>{{ item.payment_name }}</div>
										</div>
									</div>
									<div class="hong-bao-body">
										<div class="icon">
											<img src="@/assets/ic_hongbao.png" alt="">
										</div>
										<div class="hong-bao-title">限时优惠，{{ formattedCountdown }}后失效</div>
									</div>
								</div>
								<div class="price-agreement-body">
									<div class="price-body">
										<div class="price-title">
											同意协议并支付
										</div>
										<div class="price-value">
											¥{{ productsArr[selectedProductIndex].first_price > 0 ?
												productsArr[selectedProductIndex].first_price :
												productsArr[selectedProductIndex].sell_price }}
										</div>
										<div class="price-show">
											¥{{ productsArr[selectedProductIndex].show_price }}
										</div>
									</div>
									<div class="agreement-body">
										<div class="icon" @click="agreeAgreement = !agreeAgreement">
											<img :src="agreeAgreement ? require('@/assets/check_square_y.png') : require('@/assets/check_square_n.png')"
												alt="">
										</div>
										<div class="agreement-title">
											请阅读并同意
										</div>
										<div class="agreement-content">
											<label v-if="productsArr[selectedProductIndex].auto_renew == 1"
												@click="clickTerm(1)">续费协议</label>
											<label v-if="productsArr[selectedProductIndex].auto_renew == 1">|</label>
											<label @click="clickTerm(2)">用户协议</label>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { memberOptions } from '@/utils/member-options.js'
import { products } from '@/utils/api/apis.js'
import QrcodeGenerator from '@/components/qrcode_generator.vue';
import { mapState } from 'vuex'
export default {
	// import引入的组件需要注入到对象中才能使用
	components: {
		QrcodeGenerator
	},
	props: {
		isVisible: {
			type: Boolean,
			default: false
		},
		userVipInfo: {
			type: Object,
			default: {}
		}
	},
	data() {
		// 这里存放数据
		return {
			memberOptions,
			productsArr: [],
			payTypeArr: {
				wechat: {
					payment_id: '1',
					payment_name: '微信',
					icon: require('@/assets/ic_pay_wechat.png')
				},
				alipay: {
					payment_id: '2',
					payment_name: '支付宝',
					icon: require('@/assets/ic_pay_ali.png')
				},
				applePay: {
					payment_id: '3',
					payment_name: 'Apple Pay',
					icon: require('@/assets/ic_pay_ali.png')
				}
			},
			selectedPayType: '',
			payArr: [],
			selectedProductIndex: 0,
			canScrollLeft: false,
			canScrollRight: false,
			qrCodeText: '支付二维码',
			agreeAgreement: true,
			countdown: {
				days: 0,
				hours: 0,
				minutes: 0,
				seconds: 0
			},
			unsubscribe: null,
			qrCodeExpireTime: 5 * 60 * 1000, // 5分钟的毫秒数
			qrCodeTimer: null,
			isQrCodeExpired: false,
			isShowDirection: false
		}
	},
	// 过滤器
	filters: {},
	// 监听属性 类似于data概念
	computed: {
		formattedCountdown() {
			// 确保 countdown 对象包含所有必要的属性
			const { days, hours, minutes, seconds } = this.countdown;
			return this.$formatCountdown({
				days: Number(days),
				hours: Number(hours),
				minutes: Number(minutes),
				seconds: Number(seconds)
			});
		},
		...mapState('common', {
			commonData: state => state.commonData
		})
	},
	// 监控data中的数据变化
	watch: {
		isVisible: {
			immediate: true, // 添加 immediate 属性
			handler(newVal) {
				if (newVal) { // 只在数组为空时获取数据
					this.getProducts();
				}
			}
		}
	},
	// 方法集合
	methods: {
		clickTerm(type) {
			if (type == 1) {
				window.open(this.commonData.agreement.renew, '_blank');
			} else {
				window.open(this.commonData.agreement.reg, '_blank');
			}
		},
		closeDialog() {
			this.$emit('update:isVisible', false);
		},
		async getProducts() {
			try {
				this.$dialog.loading.show()
				var base = await products()
				this.productsArr = base.data;
				this.getPayType()
				this.$dialog.loading.hide()
			} catch (e) {
				this.$dialog.loading.hide()
				this.$toast(e)
				this.$errorLog('open_member_dialog/getProducts', e)
			}
		},
		selectProduct(index) {
			this.selectedProductIndex = index;
			this.getPayType()
		},
		// 控制列表滚动
		scrollList(direction) {
			const container = this.$refs.productsList;
			const scrollAmount = 200; // 每次滚动的距离

			const targetScrollLeft = direction === 'left'
				? container.scrollLeft - scrollAmount
				: container.scrollLeft + scrollAmount;

			container.scrollTo({
				left: targetScrollLeft,
				behavior: 'smooth' // 添加平滑滚动效果
			});
		},
		updateCountdown(countdownData) {
			// 确保数据更新时进行类型转换
			this.countdown = {
				days: Number(countdownData.days),
				hours: Number(countdownData.hours),
				minutes: Number(countdownData.minutes),
				seconds: Number(countdownData.seconds)
			};
		},
		createOrder() {

			console.log(this.selectedPayType, this.productsArr[this.selectedProductIndex].id)

			// 创建订单 并赋值给 qrCodeText 生成支付二维码，
			this.qrCodeText = 'ceshi'
			this.isQrCodeExpired = false
			this.startQrCodeTimer()
		},
		// 启动二维码计时器
		startQrCodeTimer() {
			// 清除已存在的计时器
			if (this.qrCodeTimer) {
				clearTimeout(this.qrCodeTimer)
			}

			// 设置新的计时器
			this.qrCodeTimer = setTimeout(() => {
				this.isQrCodeExpired = true
			}, this.qrCodeExpireTime)
		},

		// 刷新二维码
		refreshQrCode() {
			this.createOrder() // 重新创建订单获取新的二维码
		},
		changePayType(payment_id) {
			this.selectedPayType = payment_id
			this.createOrder()
		},
		// 获取支付方式
		getPayType() {
			this.payArr = []
			var paysGatewayList = this.productsArr[this.selectedProductIndex].pays_gateway_list
			paysGatewayList.forEach((item) => {
				this.payArr.push(this.payTypeArr[item]);
			})
			if (this.payArr.length > 0) {
				if (!this.payArr.find(item => item.payment_id === this.selectedPayType)) {
					this.selectedPayType = this.payArr[0].payment_id
				}
				this.createOrder()
			}
		},
		showDirection() {
			this.isShowDirection = true
		},
		hideDirection() {
			setTimeout(() => {
				this.isShowDirection = false
			}, 500)
		}
	},
	// 生命周期 - 创建完成（可以访问当前this实例）
	created() {
	},
	// 生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {
		// 使用更新方法处理订阅数据
		this.unsubscribe = this.$countdownService.subscribe((countdownData) => {
			this.updateCountdown(countdownData);
		});
	},
	beforeCreate() { }, // 生命周期 - 创建之前
	beforeMount() { }, // 生命周期 - 挂载之前
	beforeUpdate() { }, // 生命周期 - 更新之前
	updated() { }, // 生命周期 - 更新之后
	beforeDestroy() {
		if (this.unsubscribe) {
			this.unsubscribe();
			this.unsubscribe = null;
		}
		if (this.qrCodeTimer) {
			clearTimeout(this.qrCodeTimer)
		}
	}, // 生命周期 - 销毁之前
	destroyed() { }, // 生命周期 - 销毁完成
	ctivated() { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang='scss' scoped>
@font-face {
	font-family: 'OPPOSans';
	src: url('../assets/fonts/OPPOSans-H.ttf') format('truetype');
}

.modal-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgba(68, 68, 68, .2);

	.open-member-dialog {
		width: 800px;
		height: 580px;
		background: rgba(255, 255, 255, 1);
		border-radius: 16px;
		display: flex;
		flex-direction: column;

		.head-body {
			width: 100%;
			height: 110px;
			background-size: 800px 110px;

			&.bg-normal {
				background-image: url('../assets/open_member_vip_bg_n.png');
			}

			&.bg-active {
				background-image: url('../assets/open_member_vip_bg_y.png');
			}

			.head-body-msg {
				padding: 31px 0 0 44px;
				display: flex;
				align-items: flex-start;
				justify-content: center;
				flex-direction: column;
				position: relative;

				.icon-name {
					width: 83px;
					height: 20px;

					img {
						width: 83px;
						height: 20px;
					}
				}

				.head-tips {
					margin-top: 10px;
					font-size: 13px;
					color: rgba(153, 153, 153, 1);

					&.tips-vip {
						color: rgba(113, 56, 1, 1);
					}
				}

				.close-btn:hover {
					cursor: pointer;
				}

				.close-btn {
					position: absolute;
					top: 24px;
					right: 24px;
					width: 28px;
					height: 28px;

					img {
						width: 28px;
						height: 28px;
					}
				}
			}
		}

		.body-content {
			display: flex;
			align-items: center;
			justify-content: space-between;
			flex: 1;

			.content-left {
				width: 236px;
				height: 100%;
				display: flex;

				.content-left-body {
					padding: 12px 30px 0 28px;
					flex: 1;
					width: 236px;

					.left-main {
						background: linear-gradient(0deg, #FFFEFC 0%, #FFF9F2 100%);
						border-radius: 12px;
						width: 100%;
						height: 430px;
						display: flex;
						flex-direction: column;

						.left-main-title {
							font-size: 15px;
							font-weight: bold;
							background: linear-gradient(to right, rgba(192, 94, 0, 1), rgba(113, 56, 1, 1), rgba(113, 56, 1, 1));
							-webkit-background-clip: text;
							background-clip: text;
							-webkit-text-fill-color: transparent;
							width: 100%;
							display: flex;
							align-items: center;
							justify-content: center;
							margin-top: 20px;
						}

						.left-main-list {
							padding: 0 0 0 26px;
							margin-top: 24px;

							.left-main-list-item {
								display: flex;
								align-items: center;
								justify-content: flex-start;
								margin-bottom: 8px;

								.left-main-list-item-icon {
									width: 28px;
									height: 28px;
									margin-right: 14px;

									img {
										width: 28px;
										height: 28px;
									}
								}

								.left-main-list-item-title {
									font-size: 12px;
									font-weight: bold;
									color: rgba(51, 51, 51, 1);
								}
							}
						}
					}
				}
			}

			.content-right {
				flex: 1;
				height: 100%;
				overflow: hidden;

				.content-right-body {
					padding-top: 24px;

					.products-list-container {
						position: relative;

						.products-list {
							display: flex;
							overflow-x: auto;
							position: relative;
							// 隐藏滚动条但保持可滚动
							scrollbar-width: none; // Firefox
							-ms-overflow-style: none; // IE and Edge

							&::-webkit-scrollbar {
								display: none; // Chrome, Safari, Opera
							}

							.product-item {
								display: flex;
								flex-direction: column;
								align-items: center;
								justify-content: center;
								margin-right: 10px;
								position: relative;
								padding-top: 8px;

								.product-item-body {
									min-width: 118px;
									height: 140px;
									border: 1px solid rgba(221, 221, 221, 1);
									border-radius: 13px;
									cursor: pointer;
									background-color: rgba(255, 255, 255, 1);
									display: flex;
									flex-direction: column;
									align-items: center;
									justify-content: flex-start;

									.product-title {
										color: rgba(34, 34, 34, 1);
										font-size: 13px;
										font-weight: bold;
										margin-top: 20px;
									}

									.product-title-selected {
										color: rgba(113, 56, 1, 1);
									}

									.product-price-body {
										display: flex;
										align-items: flex-end;
										justify-content: center;
										font-family: 'OPPOSans';
										height: 50px;

										div {
											&:first-child {
												// ¥ 符号
												font-size: 18px;
												margin-top: 12px;
											}

											&:last-child {
												// 价格数字
												font-size: 32px;
											}
										}
									}

									.product-price-body-selected {
										color: rgba(113, 56, 1, 1);
									}

									.product-price-show {
										text-decoration-line: line-through;
										font-size: 12px;
										color: rgba(34, 34, 34, 0.60);
									}

									.product-price-show-selected {
										color: rgba(113, 56, 1, 0.60);
									}

									.product-price-discount {
										height: 20px;
										width: 102px;
										border-radius: 6px;
										background-color: rgba(238, 238, 238, 1);
										color: rgba(34, 34, 34, 1);
										display: flex;
										align-items: center;
										justify-content: center;
										font-size: 12px;
										margin-top: 6px;
									}

									.product-price-discount-selected {
										background-color: rgba(255, 206, 160, 1);
										color: rgba(113, 56, 1, 0.90);
									}
								}

								.product-item-body-selected {
									border: 1px solid rgba(255, 191, 129, 1);
									background: linear-gradient(180deg, #FFEBD8 0%, #FFF6ED 100%);
								}

								.product-lable {
									position: absolute;
									top: 0;
									left: 0;
									background: linear-gradient(270deg, #FF177E 0%, #FF7429 100%);
									border-radius: 13px 13px 13px 0px;
									font-size: 11px;
									color: rgba(255, 255, 255, 0.90);
									padding: 0 8px;
									height: 18px;
									display: flex;
									align-items: center;
									justify-content: center;
								}
							}
						}

						.icon-direction {
							position: absolute;
							top: 52px;
							width: 36px;
							height: 36px;
							cursor: pointer;
							z-index: 1;
							transition: all 0.3s;

							img {
								width: 36px;
								height: 36px;
							}
						}

						.icon-direction-left {
							left: 6px;
						}

						.icon-direction-right {
							right: 6px;
							transform: rotate(180deg);
						}
					}

					.auto-renew-tip {
						height: 70px;

						.auto-renew-tip-title {
							padding-top: 16px;
							font-size: 12px;
							color: rgba(153, 153, 153, 1);

						}
					}

					.pay-content {
						display: flex;
						align-items: center;
						justify-content: flex-start;
						height: 180px;

						.qrcode-body {
							box-sizing: border-box;
							border: 1px solid rgba(221, 221, 221, 1);
							border-radius: 12px;
							width: 140px;
							height: 180px;
							display: flex;
							flex-direction: column;

							.qrcode-body-content {
								flex: 1;
								display: flex;
								align-items: center;
								justify-content: space-between;
								flex-direction: column;
								padding: 16px 10px 14px 10px;

								.qrcode {
									max-width: 120px;
									max-height: 120px;
									position: relative;

									.refresh-body {
										cursor: pointer;
										position: absolute;
										top: 0;
										left: 0;
										width: 120px;
										height: 120px;
										background-image: url('../assets/ic_refresh_bg.png');
										background-size: 120px 120px;
										background-repeat: no-repeat;
										background-position: center;
										display: flex;
										align-items: center;
										justify-content: center;
										flex-direction: column;

										.refresh-ic {
											width: 28px;
											height: 28px;
											display: flex;
											align-items: center;
											justify-content: center;

											img {
												width: 28px;
												height: 28px;
											}
										}

										.refresh-tip {
											font-size: 13px;
											color: rgba(255, 255, 255, 1);
											margin-top: 10px;
										}
									}
								}

								.qrcode-title {
									font-size: 13px;
									color: rgba(102, 102, 102, 1);
								}
							}
						}

						.pay-type-body {
							flex: 1;
							width: 100%;
							height: 100%;
							padding-left: 24px;
							padding-right: 46px;
							display: flex;
							align-items: center;
							justify-content: space-between;
							flex-direction: column;

							.pay-type-body-content {
								width: 100%;

								.pay-type-arr {
									display: flex;
									align-items: center;
									justify-content: center;
									background-color: rgba(242, 242, 242, 1);
									width: 100%;
									height: 42px;
									border-radius: 10px;
									padding: 3px;
									box-sizing: border-box;

									.pay-item {
										font-size: 13px;
										flex: 1;
										background-color: rgba(242, 242, 242, 1);
										border-radius: 6px;
										display: flex;
										align-items: center;
										justify-content: center;
										height: 100%;
										cursor: pointer;
									}

									.pay-item-selected {
										background-color: rgba(255, 255, 255, 1);
									}
								}

								.hong-bao-body {
									display: flex;
									align-items: center;
									justify-content: flex-start;
									margin-top: 14px;
									background: linear-gradient(270deg, #FF8140 0%, #FF1212 100%);
									border-radius: 6px;
									width: 100%;
									height: 24px;
									padding: 0 9px;
									box-sizing: border-box;

									.icon {
										width: 15px;
										height: 18px;

										img {
											width: 15px;
											height: 15px;
										}
									}

									.hong-bao-title {
										font-size: 13px;
										color: rgba(255, 255, 255, 1);
										margin-left: 12px;
									}
								}
							}

							.price-agreement-body {
								display: flex;
								align-items: flex-start;
								justify-content: flex-start;
								flex-direction: column;
								width: 100%;

								.price-body {
									display: flex;
									align-items: center;
									justify-content: flex-start;

									.price-title {
										margin-top: 8px;
										margin-right: 10px;
										font-size: 18px;
										color: rgba(34, 34, 34, 1);
										font-weight: bold;
									}

									.price-value {
										font-size: 36px;
										color: rgba(248, 123, 0, 1);
										font-family: 'OPPOSans';
									}

									.price-show {
										margin-left: 6px;
										font-size: 12px;
										color: rgba(34, 34, 34, 0.50);
										text-decoration-line: line-through;
										margin-top: 12px;
									}
								}

								.agreement-body {
									display: flex;
									align-items: center;
									justify-content: flex-start;

									.icon {
										width: 16px;
										height: 16px;
										display: flex;
										align-items: center;
										justify-content: center;
										cursor: pointer;

										img {
											width: 16px;
											height: 16px;
										}
									}

									.agreement-title {
										display: flex;
										align-items: center;
										justify-content: flex-start;
										font-size: 13px;
										color: rgba(153, 153, 153, 1);
										margin-left: 10px;
									}

									.agreement-content {
										color: rgba(102, 102, 102, 1);
										margin-left: 4px;
										font-size: 13px;
										cursor: pointer;

										label {
											font-size: 13px;
											margin: 0 2px;
											color: rgba(153, 153, 153, 1);
											cursor: pointer;
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/open_member_dialog.vue